import axios from 'axios';
export async function getGroupCodeStatus (url, tempId) {
 let groupCodeResponse = {}
 let params = {
  enrollment_id: tempId,
 }
 try {
   const response = await axios.get(url, { params })
   if (response.data.status === 'success') {
    groupCodeResponse = response.data.data;
   }
 } catch (error) {
  console.log(error)
 }
 return groupCodeResponse
}

/* Api to validate zip */
export const zipValidation = (zip) => {
    return (axios.post(
        `${process.env.VUE_APP_API_SERVICE}/api/v1/service/validate-zip-code`,
        { 'zip': zip }
    ).then(response => {
        if (response.status === 200) {
            return response.data;
        }
    }).catch(error => {
        if (error.response?.data?.status === 'error') {
            throw error.response.data.data[0];
        }
        throw error;
    }));
};